import React from 'react';

import { theme } from 'Theme';
import { assignCssVars, buildClassnames } from '../../utils';
import { FlexRow } from '../Flex/FlexRow';
import { FlexProps } from '../Flex/types';
import { Text } from '../Text';

import styles from './Tag.module.scss';

type TagProps = Omit<FlexProps, 'color'> & {
  backgroundColor?: string;
  textColor?: string;
  label?: string;
  compact?: boolean;
  leftIconSlot?: React.ReactNode;
  rightIconSlot?: React.ReactNode;
};

export const Tag = ({
  className,
  backgroundColor = theme.colors.neutral.grey.base,
  textColor,
  children,
  label,
  compact = false,
  leftIconSlot,
  rightIconSlot,
  ...otherProps
}: TagProps) => (
  <FlexRow
    flexWrap="nowrap"
    justifyContent="center"
    gap="xs"
    className={buildClassnames([styles.tag, compact && styles.compact, className])}
    style={{ ...assignCssVars({ customTextColor: textColor }), backgroundColor }}
    {...otherProps}
  >
    {leftIconSlot}
    {children || <Text variant="body">{label}</Text>}
    {rightIconSlot}
  </FlexRow>
);
